import { useBaseFontSize as n, useUsingKeyboardContext as e } from "@leafygreen-ui/leafygreen-provider";
import { BaseFontSize as r, fontFamilies as a, typeScales as t } from "@leafygreen-ui/tokens";
import o, { useState as i, useEffect as l, useMemo as s } from "react";
import c from "@leafygreen-ui/box";
import { css as d, cx as p } from "@leafygreen-ui/emotion";
import { palette as u } from "@leafygreen-ui/palette";
import { jsx as f } from "@emotion/react";
import { createDataProp as g } from "@leafygreen-ui/lib";
import m from "@leafygreen-ui/icon/dist/ArrowRight";
import h from "@leafygreen-ui/icon/dist/OpenNewTab";

var y,
    b,
    x,
    v,
    N = function N(e) {
  var a = n();
  return e ? 16 === e ? r.Body2 : r.Body1 : 16 === a ? r.Body2 : r.Body1;
};

function w(n, e, r) {
  return e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}

function k() {
  return k = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var a in r) {
        Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
      }
    }

    return n;
  }, k.apply(this, arguments);
}

function z(n, e) {
  if (null == n) return {};

  var r,
      a,
      t = function (n, e) {
    if (null == n) return {};
    var r,
        a,
        t = {},
        o = Object.keys(n);

    for (a = 0; a < o.length; a++) {
      r = o[a], e.indexOf(r) >= 0 || (t[r] = n[r]);
    }

    return t;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);

    for (a = 0; a < o.length; a++) {
      r = o[a], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
    }
  }

  return t;
}

function F(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

function O(n, e) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, e) {
    var r = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null == r) return;
    var a,
        t,
        o = [],
        i = !0,
        l = !1;

    try {
      for (r = r.call(n); !(i = (a = r.next()).done) && (o.push(a.value), !e || o.length !== e); i = !0) {
        ;
      }
    } catch (n) {
      l = !0, t = n;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw t;
      }
    }

    return o;
  }(n, e) || function (n, e) {
    if (!n) return;
    if ("string" == typeof n) return D(n, e);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    "Object" === r && n.constructor && (r = n.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(n);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return D(n, e);
  }(n, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function D(n, e) {
  (null == e || e > n.length) && (e = n.length);

  for (var r = 0, a = new Array(e); r < e; r++) {
    a[r] = n[r];
  }

  return a;
}

var j,
    B = d(y || (y = F(["\n  margin: unset;\n  font-family: ", ";\n  color: ", ";\n"])), a.default, u.black),
    S = d(b || (b = F(["\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0px;\n"]))),
    A = d(x || (x = F(["\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0px;\n"]))),
    I = d(v || (v = F(["\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0px;\n"]))),
    C = ["className"],
    E = d(j || (j = F(["\n  font-weight: 400;\n  font-size: 48px;\n  line-height: 62px;\n  letter-spacing: -0.3px;\n  font-family: ", ";\n  color: ", ";\n"])), a.serif, u.green.dark2),
    H = function H(n) {
  var e = n.className,
      r = z(n, C);
  return f(c, k({
    as: "h1",
    className: p(B, E, e)
  }, r));
};

H.displayName = "H1";

var M,
    P = ["className"],
    _ = d(M || (M = F(["\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.3px;\n  font-weight: 400;\n  font-family: ", ";\n  color: ", ";\n"])), a.serif, u.green.dark2),
    K = function K(n) {
  var e = n.className,
      r = z(n, P);
  return f(c, k({
    as: "h2",
    className: p(B, _, e)
  }, r));
};

K.displayName = "H2";

var L,
    R = ["className"],
    T = d(L || (L = F(["\n  font-size: 24px;\n  line-height: 32px;\n  letter-spacing: -0.3px;\n  font-weight: 600;\n"]))),
    U = function U(n) {
  var e = n.className,
      r = z(n, R);
  return f(c, k({
    as: "h3",
    className: p(B, T, e)
  }, r));
};

U.displayName = "H3";

var $,
    q,
    G = ["className"],
    J = d($ || ($ = F(["\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.3px;\n  font-weight: 700;\n"]))),
    Q = function Q(n) {
  var e = n.className,
      r = z(n, G);
  return f(c, k({
    as: "h6",
    className: p(B, J, e)
  }, r));
};

Q.displayName = "Subtitle";
var V = ["className", "weight", "as"];

function W(e) {
  var r = e.className,
      a = e.weight,
      t = void 0 === a ? "regular" : a,
      o = e.as,
      i = void 0 === o ? "p" : o,
      l = z(e, V),
      s = 16 === n() ? A : S,
      u = {
    default: {
      regular: 400,
      medium: 500
    },
    strong: {
      regular: 700,
      medium: 800
    }
  },
      g = d(q || (q = F(["\n    font-weight: ", ";\n    strong,\n    b {\n      font-weight: ", ";\n    }\n  "])), u.default[t], u.strong[t]);
  return f(c, k({
    as: i,
    className: p(B, s, g, r)
  }, l));
}

W.displayName = "Body";

var X,
    Y = ["className"],
    Z = d(X || (X = F(["\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  line-height: 16px;\n  letter-spacing: 0.3px;\n"]))),
    nn = function nn(n) {
  var e = n.className,
      r = z(n, Y);
  return f(c, k({
    className: p(B, Z, e)
  }, r));
};

nn.displayName = "Overline";
var en,
    rn,
    an,
    tn,
    on,
    ln,
    sn,
    cn,
    dn,
    pn,
    un,
    fn,
    gn,
    mn = ["children", "className", "darkMode"],
    hn = g("anchor-inline-code"),
    yn = d(en || (en = F(["\n  transition: all 0.15s ease-in-out;\n  border-radius: 3px;\n  font-family: ", ";\n\n  ", ":hover > & {\n    text-decoration: none;\n  }\n"])), a.code, hn.selector),
    bn = "light",
    xn = "dark",
    vn = (w(tn = {}, bn, d(rn || (rn = F(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    ", ":hover > & {\n      box-shadow: 0 0 0 3px ", ";\n      border: 1px solid ", ";\n    }\n  "])), u.gray.light3, u.gray.light2, u.gray.dark3, hn.selector, u.gray.light2, u.gray.light1)), w(tn, xn, d(an || (an = F(["\n    background-color: transparent;\n    border: 1px solid ", ";\n    color: ", ";\n\n    ", ":hover > & {\n      box-shadow: 0 0 0 3px ", ";\n      border: 1px solid ", ";\n    }\n  "])), u.gray.dark1, u.gray.light3, hn.selector, u.gray.dark1, u.gray.base)), tn),
    Nn = (w(sn = {}, bn, d(on || (on = F(["\n    ", ":focus > & {\n      box-shadow: 0 0 0 2px ", ", 0 0 0 4px ", ";\n      border: 1px solid ", ";\n    }\n  "])), hn.selector, u.white, u.blue.light1, u.blue.base)), w(sn, xn, d(ln || (ln = F(["\n    ", ":focus > & {\n      box-shadow: 0 0 0 2px ", ", 0 0 0 4px ", ";\n      border: 1px solid ", ";\n    }\n  "])), hn.selector, u.black, u.blue.light1, u.blue.base)), sn),
    wn = (w(pn = {}, bn, d(cn || (cn = F(["\n    color: ", ";\n  "])), u.blue.base)), w(pn, xn, d(dn || (dn = F(["\n    color: ", ";\n  "])), u.blue.light1)), pn),
    kn = d(un || (un = F(["\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n"]))),
    zn = d(fn || (fn = F(["\n  white-space: nowrap;\n"]))),
    Fn = d(gn || (gn = F(["\n  white-space: normal;\n"])));

function On(r) {
  var a,
      t,
      i,
      l = r.children,
      s = r.className,
      c = r.darkMode,
      d = z(r, mn),
      u = e().usingKeyboard,
      g = 16 === n() ? I : S,
      m = c ? xn : bn,
      h = (null !== (a = "string" == typeof l && (null === (t = l.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) || void 0 === t ? void 0 : t.length)) && void 0 !== a ? a : 0) <= 30 ? zn : Fn,
      y = void 0 !== (null == d ? void 0 : d.href) || void 0 !== d.onClick,
      b = f("code", {
    className: p(yn, vn[m], g, h, (i = {}, w(i, wn[m], y), w(i, Nn[m], u), i), s)
  }, l);
  return y ? f("a", k({}, hn.prop, {
    className: p(kn, s)
  }, d), b) : o.cloneElement(b, d);
}

On.displayName = "InlineCode";
var Dn,
    jn = ["children", "className"],
    Bn = d(Dn || (Dn = F(["\n  font-family: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  padding-left: 4px;\n  padding-right: 4px;\n"])), a.code, u.gray.dark3, u.gray.dark3);

function Sn(e) {
  var r = e.children,
      a = e.className,
      t = z(e, jn),
      o = n();
  return f("code", k({
    className: p(Bn, 16 === o ? I : S, a)
  }, t), r);
}

Sn.displayName = "InlineKeyCode";

var An,
    In,
    Cn,
    En,
    Hn,
    Mn,
    Pn,
    _n,
    Kn,
    Ln,
    Rn = "light",
    Tn = "dark",
    Un = ["darkMode", "disabled", "children", "className"],
    $n = d(An || (An = F(["\n  font-family: ", ";\n  font-weight: normal;\n  margin-top: 0;\n  margin-bottom: 0;\n"])), a.default),
    qn = (w(En = {}, r.Body1, d(In || (In = F(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), t.body1.fontSize, t.body1.lineHeight)), w(En, r.Body2, d(Cn || (Cn = F(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), t.body2.fontSize, t.body2.lineHeight)), En),
    Gn = (w(Pn = {}, Rn, d(Hn || (Hn = F(["\n    color: ", ";\n  "])), u.gray.dark1)), w(Pn, Tn, d(Mn || (Mn = F(["\n    color: ", ";\n  "])), u.gray.light1)), Pn),
    Jn = (w(Ln = {}, Rn, d(_n || (_n = F(["\n    color: ", ";\n  "])), u.gray.base)), w(Ln, Tn, d(Kn || (Kn = F(["\n    color: ", ";\n  "])), u.gray.light1)), Ln),
    Qn = function Qn(n) {
  var e = n.darkMode,
      r = void 0 !== e && e,
      a = n.disabled,
      t = void 0 !== a && a,
      o = n.children,
      i = n.className,
      l = z(n, Un),
      s = N(),
      c = r ? Tn : Rn;
  return f("p", k({
    className: p($n, Gn[c], qn[s], w({}, Jn[c], t), i)
  }, l), o);
};

Qn.displayName = "Description";
var Vn,
    Wn = ["children", "className"],
    Xn = d(Vn || (Vn = F(["\n  display: block;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0px;\n"])));

function Yn(n) {
  var e = n.children,
      r = n.className,
      a = z(n, Wn);
  return f("small", k({}, a, {
    className: p(B, Xn, r)
  }), e);
}

Yn.displayName = "Disclaimer";

var Zn,
    ne,
    ee,
    re,
    ae,
    te,
    oe,
    ie,
    le,
    se,
    ce = ["darkMode", "className", "children", "disabled"],
    de = d(Zn || (Zn = F(["\n  font-family: ", ";\n  font-weight: bold;\n"])), a.default),
    pe = (w(re = {}, r.Body1, d(ne || (ne = F(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), t.body1.fontSize, t.body1.lineHeight)), w(re, r.Body2, d(ee || (ee = F(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), t.body2.fontSize, t.body2.lineHeight)), re),
    ue = (w(oe = {}, Rn, d(ae || (ae = F(["\n    color: ", ";\n  "])), u.black)), w(oe, Tn, d(te || (te = F(["\n    color: ", ";\n  "])), u.white)), oe),
    fe = (w(se = {}, Rn, d(ie || (ie = F(["\n    color: ", ";\n  "])), u.gray.base)), w(se, Tn, d(le || (le = F(["\n    color: ", ";\n  "])), u.gray.light1)), se),
    ge = function ge(n) {
  var e = n.darkMode,
      r = void 0 !== e && e,
      a = n.className,
      t = n.children,
      o = n.disabled,
      i = void 0 !== o && o,
      l = z(n, ce),
      s = N(),
      c = r ? Tn : Rn;
  return f("label", k({
    className: p(de, ue[c], pe[s], w({}, fe[c], i), a)
  }, l), t);
};

ge.displayName = "Label";

var me,
    he,
    ye,
    be,
    xe,
    ve = ["href", "children", "className", "target", "arrowAppearance", "hideExternalIcon"],
    Ne = g("anchor-container"),
    we = d(me || (me = F(["\n  font-family: ", ";\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n"])), a.default, u.blue.base),
    ke = d(he || (he = F(["\n  background-repeat: repeat-x;\n  background-size: 2px 2px;\n  background-position: center bottom;\n\n  ", ":hover & {\n    background-image: linear-gradient(\n      ", " 100%,\n      ", " 0\n    );\n  }\n\n  ", ":focus & {\n    background-image: linear-gradient(\n      to right,\n      ", " 100%,\n      ", " 0\n    );\n  }\n"])), Ne.selector, u.gray.light2, u.gray.light2, Ne.selector, u.blue.light1, u.blue.light1),
    ze = d(ye || (ye = F(["\n  transform: translate3d(3px, 0, 0);\n"]))),
    Fe = d(be || (be = F(["\n  opacity: 0;\n  transform: translate3d(-3px, 0, 0);\n  transition: all 100ms ease-in;\n\n  ", ":hover & {\n    opacity: 1;\n    transform: translate3d(3px, 0, 0);\n  }\n"])), Ne.selector),
    Oe = d(xe || (xe = F(["\n  position: relative;\n  bottom: 4px;\n  left: -1px;\n  height: 12px;\n"]))),
    De = "hover",
    je = "persist",
    Be = "none",
    Se = function Se(e) {
  var r = e.href,
      a = e.children,
      t = e.className,
      o = e.target,
      d = e.arrowAppearance,
      u = void 0 === d ? Be : d,
      g = e.hideExternalIcon,
      y = void 0 !== g && g,
      b = z(e, ve),
      x = O(i(""), 2),
      v = x[0],
      N = x[1];
  l(function () {
    N(window.location.hostname);
  }, []);
  var F,
      D,
      j,
      B = s(function () {
    if (r) {
      return /^http(s)?:\/\//.test(r) ? new URL(r).hostname : v;
    }
  }, [r, v]),
      I = 16 === n() ? A : S;

  if (o ? F = o : B === v ? F = "_self" : (F = "_blank", j = "noopener noreferrer"), "_blank" !== F || y) {
    if (u !== Be) {
      var C;
      D = f(m, {
        role: "presentation",
        size: 12,
        className: p((C = {}, w(C, Fe, u === De), w(C, ze, u === je), C))
      });
    }
  } else D = f(h, {
    role: "presentation",
    className: Oe
  });

  var E = r ? {
    as: "a",
    href: r,
    target: F,
    rel: j
  } : {
    as: "span"
  };
  return f(c, k({
    className: p(we, I, t)
  }, E, Ne.prop, b), f("span", {
    className: ke
  }, a), D);
};

export { W as Body, Qn as Description, Yn as Disclaimer, H as H1, K as H2, U as H3, On as InlineCode, Sn as InlineKeyCode, ge as Label, Se as Link, nn as Overline, Q as Subtitle, N as useUpdatedBaseFontSize };